"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStore = void 0;
var mobx_1 = require("mobx");
var inversify_1 = require("inversify");
var Store_1 = require("./Store");
var GlobalStore = /** @class */ (function (_super) {
    __extends(GlobalStore, _super);
    function GlobalStore() {
        var _this = _super.call(this) || this;
        Object.defineProperty(_this, "initialising", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "initialised", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        mobx_1.makeObservable(_this, {
            initialising: mobx_1.observable,
            initialised: mobx_1.observable,
            error: mobx_1.observable,
        });
        return _this;
    }
    GlobalStore = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [])
    ], GlobalStore);
    return GlobalStore;
}(Store_1.Store));
exports.GlobalStore = GlobalStore;
//# sourceMappingURL=GlobalStore.js.map